import { Fragment, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon, Text } from "@chakra-ui/react";
import { FaCalendarAlt, FaHome, FaInbox, FaUserAlt } from "react-icons/fa";
import { CgQr } from "react-icons/cg";
import { useAuth } from "../helpers/useAuth";

export default function Menu() {
  const router = useLocation();
  const { role } = useAuth();

  function currentPage(val) {
    return router.pathname === val.link;
  }

  const menuItem = useMemo(() => {
    return [
      {
        title: "Home",
        icon: FaHome,
        link: "/",
        role: ["user", undefined],
      },
      {
        title: "Inbox",
        icon: FaInbox,
        link: "/inbox",
        role: ["user", undefined],
      },
      {
        title: "Event",
        icon: FaCalendarAlt,
        link: "/event",
        role: ["admin"],
      },
      {
        title: "Scan QR",
        icon: CgQr,
        link: "/scan",
        role: ["admin"],
      },
      {
        title: "Profile",
        icon: FaUserAlt,
        link: "/profile",
        role: ["admin", "user", undefined],
      },
    ];
  }, []);

  return (
    <div className="main-menu">
      <div className="menu-content">
        {menuItem.map((val, k) => {
          return (
            <Fragment key={k}>
              {val["role"].includes(role) && (
                <div className="menu-item">
                  <Link
                    to={val.link}
                    style={{
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    <Icon
                      as={val.icon}
                      w={4}
                      h={4}
                      color={currentPage(val) ? "blue.500" : "gray.400"}
                    />
                    <Text
                      fontSize="xs"
                      color={currentPage(val) ? "blue.500" : "gray.400"}
                    >
                      {val.title}
                    </Text>
                  </Link>
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
